import * as React from "react";

export class MutableComponent<P = object, S = object> extends React.Component<P, S> {
	modifyState(next: Partial<S>) {
		this.setState(Object.assign({}, this.state, next));
	}
}
